import React, { Children } from 'react';
import { FadeIn } from './ui/FadeIn';
import { Check, X } from 'lucide-react';
import { motion } from 'framer-motion';
export function TargetAudienceSection() {
  const isFor = ['Mujeres que sienten que si ellas no están, todo se desmorona.', "Profesionales exitosas que se sienten 'secas' o desconectadas de su erotismo y gozo.", 'Madres que llevan el 100% de la carga mental del hogar.', "Mujeres solteras que están cansadas de 'cazar' y quieren volver a 'atraer'."];
  const isNotFor = ['Quienes buscan una solución mágica sin mirar sus miedos al control.', 'Quienes prefieren culpar a los demás en lugar de transformar su propia energía.', 'Mujeres que no están dispuestas a soltar el perfeccionismo.'];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      x: -10
    },
    visible: {
      opacity: 1,
      x: 0
    }
  };
  return <section className="py-20 bg-white" data-id="element-197">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-198">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-199">
          {/* Who this is for */}
          <FadeIn direction="right" data-id="element-200">
            <div className="bg-cream/50 p-8 md:p-10 rounded-3xl h-full border border-gold/20" data-id="element-201">
              <h3 className="text-2xl font-serif text-brown mb-8 flex items-center" data-id="element-202">
                <span className="w-8 h-8 rounded-full bg-gold/20 flex items-center justify-center mr-3" data-id="element-203">
                  <Check className="w-5 h-5 text-gold-dark" data-id="element-204" />
                </span>
                Esto es para ti si...
              </h3>
              <motion.ul variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
              once: true
            }} className="space-y-5" data-id="element-205">
                {isFor.map((item, index) => <motion.li key={index} variants={itemVariants} className="flex items-start" data-id="element-206">
                    <Check className="w-5 h-5 text-gold mt-1 mr-3 flex-shrink-0" data-id="element-207" />
                    <span className="text-brown/80 leading-relaxed" data-id="element-208">
                      {item}
                    </span>
                  </motion.li>)}
              </motion.ul>
            </div>
          </FadeIn>

          {/* Who this is not for */}
          <FadeIn direction="left" delay={0.2} data-id="element-209">
            <div className="bg-rose-light/10 p-8 md:p-10 rounded-3xl h-full border border-rose-light/30" data-id="element-210">
              <h3 className="text-2xl font-serif text-brown mb-8 flex items-center" data-id="element-211">
                <span className="w-8 h-8 rounded-full bg-rose-light/30 flex items-center justify-center mr-3" data-id="element-212">
                  <X className="w-5 h-5 text-rose" data-id="element-213" />
                </span>
                Esto NO es para ti si...
              </h3>
              <motion.ul variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
              once: true
            }} className="space-y-5" data-id="element-214">
                {isNotFor.map((item, index) => <motion.li key={index} variants={itemVariants} className="flex items-start" data-id="element-215">
                    <X className="w-5 h-5 text-rose mt-1 mr-3 flex-shrink-0" data-id="element-216" />
                    <span className="text-brown/80 leading-relaxed" data-id="element-217">
                      {item}
                    </span>
                  </motion.li>)}
              </motion.ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}